import PropTypes from 'prop-types';
import React from 'react';

import { CS_MEASURES, MEASURE_NAMES } from '../../../../constants/assessments';
import MeasureScore from '../../measure-score/MeasureScore';
import {
    constructBurstScoreLink,
    linkOnClickHandler,
} from '../../../../common/navigation/navigation';
import { burstProbeResultType } from '../../../../constants/prop-types';

const BurstMeasureScore = ({ measure, measureResult, params }) => {
    if (CS_MEASURES.includes(measure)) {
        if (measure === MEASURE_NAMES.CS_PASSAGE) {
            const retellResult = measureResult.results.find(
                result => result.measure === MEASURE_NAMES.CS_RETELL,
            );
            const recallResult = measureResult.results.find(
                result => result.measure === MEASURE_NAMES.CS_RECALL,
            );
            if (retellResult) {
                const scoreParams = {
                    ...params,
                    measure: MEASURE_NAMES.CS_RETELL,
                    assmtResultId: measureResult.id,
                };
                return (
                    <MeasureScore
                        score={retellResult.score}
                        onClick={linkOnClickHandler(constructBurstScoreLink(scoreParams))}
                        path={constructBurstScoreLink(scoreParams)}
                    />
                );
            }
            if (recallResult) {
                const scoreParams = {
                    ...params,
                    measure: MEASURE_NAMES.CS_RECALL,
                    assmtResultId: measureResult.id,
                };
                return (
                    <MeasureScore
                        score={recallResult.score}
                        onClick={linkOnClickHandler(constructBurstScoreLink(scoreParams))}
                        path={constructBurstScoreLink(scoreParams)}
                    />
                );
            }
        } else {
            const csResult = measureResult.results.find(result => result.measure === measure);
            if (csResult) {
                const scoreParams = {
                    ...params,
                    assmtResultId: measureResult.id,
                };
                return (
                    <MeasureScore
                        score={csResult.score}
                        onClick={linkOnClickHandler(constructBurstScoreLink(scoreParams))}
                        path={constructBurstScoreLink(scoreParams)}
                    />
                );
            }
        }
    }
    const scoreParams = {
        ...params,
        assmtResultId: measureResult.id,
    };
    return (
        <MeasureScore
            score={measureResult.overallScore}
            onClick={linkOnClickHandler(constructBurstScoreLink(scoreParams))}
            path={constructBurstScoreLink(scoreParams)}
        />
    );
};

BurstMeasureScore.propTypes = {
    measure: PropTypes.string.isRequired,
    measureResult: PropTypes.shape({
        id: PropTypes.string.isRequired,
        results: PropTypes.arrayOf(burstProbeResultType),
        overallScore: PropTypes.number,
    }).isRequired,
    params: PropTypes.shape({
        studentId: PropTypes.string.isRequired,
        period: PropTypes.string.isRequired,
        measure: PropTypes.string.isRequired,
        classeId: PropTypes.string.isRequired,
    }).isRequired,
};

export default BurstMeasureScore;
